import React, { useState, useEffect } from "react";
import { fetchPoolModels } from "../../../utils/Pool/fetchPoolModels";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { getDownloadLink } from "../../../utils/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import RenderModel from "../../RenderModel";

const initialTimeline = [
    { date: "23.03.2025", address: "Berlin, Germany", models: [] },
    { date: "22.03.2025", address: "Paris, France", models: [] },
    { date: "01.04.2025", address: "Madrid, Spain", models: [] }
];

const BookingEditView = ({ selectedBooking = null, setSelectedBooking = () => { }, bookings, setIsEditMode = () => { } }) => {
    const [models, setModels] = useState([]);
    const [timeline, setTimeline] = useState(initialTimeline);

    // Modal State
    const [isOpen, setIsOpen] = useState(false);
    const [newDate, setNewDate] = useState(new Date());
    const [newAddress, setNewAddress] = useState("");

    useEffect(() => {
        if (selectedBooking) {
            fetchPoolModels(
                selectedBooking.pool_id,
                (fetchedModels) => {
                    setModels(fetchedModels);

                    // Insert the first model into the first timeline entry
                    if (fetchedModels.length > 0) {
                        setTimeline((prevTimeline) => {
                            const updated = [...prevTimeline];
                            updated[0] = {
                                ...updated[0],
                                models: [fetchedModels[0]]
                            };
                            updated[1] = {
                                ...updated[1],
                                models: [fetchedModels[0], fetchedModels[1]]
                            };
                            return updated;
                        });
                    }
                },
                () => { },
                () => { },
                1,
                10
            );
        }
    }, [selectedBooking]);

    // Handle drag and drop
    const onDragEnd = (result) => {
        const { source, destination } = result;
        if (!destination) return;

        if (source.droppableId === "modelSelection") {
            const draggedModel = models.find((m) => String(m.id) === result.draggableId);
            if (!draggedModel) return;

            setTimeline((prevTimeline) =>
                prevTimeline.map((entry) =>
                    entry.date === destination.droppableId
                        ? { ...entry, models: Array.from(new Set([...entry.models, draggedModel])) }
                        : entry
                )
            );
        }
    };

    // Function to Add a New Timeline Entry
    const handleAddTimelineEntry = () => {
        if (!newDate || !newAddress) {
            alert("Please enter both date and address.");
            return;
        }

        const formattedDate = format(newDate, "dd.MM.yyyy"); // Format date

        const newEntry = {
            date: formattedDate,
            address: newAddress,
            models: []
        };

        setTimeline([...timeline, newEntry]);
        setIsOpen(false);
        setNewDate(new Date());
        setNewAddress("");
    };

    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px", padding: "20px" }}>
                <button className="big-button" onClick={() => { setIsEditMode(false) }}>cancel Editing</button>
                {/* Button to Open Modal */}
                <button
                    onClick={() => setIsOpen(true)}
                    className="big-button"
                >
                    + Add Timeline Entry
                </button>

                <h3 className="modal-title">Models in {selectedBooking.pool_id}</h3>
                {models.length > 0 && (
                    <Droppable droppableId="modelSelection" direction="horizontal" isDropDisabled={true}>
                        {(provided) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className="model-list"
                            >
                                {models.map((model, index) => (
                                    <Draggable key={String(model.id)} draggableId={String(model.id)} index={index}>
                                        {(provided, snapshot) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={{
                                                    ...provided.draggableProps.style,
                                                    opacity: snapshot.isDragging ? 0.9 : 1.0,
                                                    padding: "10px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",

                                                }}
                                            >
                                                <RenderModel model={model} />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                )}

                <hr></hr>

                <h1 className="title">Timeline</h1>
                {timeline.map((entry, index) => (
                    <Droppable key={`${entry.date}-${index}`} droppableId={entry.date}>
                        {(provided, snapshot) => (
                            <div
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                style={{
                                    padding: "15px",
                                    borderRadius: "5px",
                                    background: snapshot.isDraggingOver ? "lightgreen" : "#d0d8e1",
                                    display: "flex",
                                    gap: "10px",
                                    minHeight: "100px",
                                }}
                            >
                                <div style={{ minWidth: "150px", fontWeight: "bold", textAlign: "center", alignSelf: "center" }}>
                                    {entry.date} - {entry.address}
                                </div>

                                {entry.models.length === 0 && (
                                    <div style={{ padding: "20px", background: "lightgrey", textAlign: "center", alignSelf: "center" }}>
                                        Drop models here
                                    </div>
                                )}

                                <div className="model-timeline">

                                    {entry.models.map((model) => (
                                        <div
                                            style={{
                                                padding: "5px",
                                                background: "#fff",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                            }}
                                            key={model.id + "timeline"}
                                        >
                                            <RenderModel model={model} modelStyle="model-item-timeline" />
                                        </div>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            </div>
                        )}
                    </Droppable>
                ))}

                {/* Popup Modal */}
                {isOpen && (
                    <div style={{
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        background: "white",
                        padding: "20px",
                        borderRadius: "10px",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                        zIndex: 1000,
                        minWidth: "320px",
                    }}>
                        <h3>Add Timeline Entry</h3>
                        <label>Date:</label>
                        <DatePicker
                            selected={newDate}
                            onChange={(date) => setNewDate(date)}
                            dateFormat="dd.MM.yyyy"
                        />

                        <label>Address:</label>
                        <input type="text" value={newAddress} onChange={(e) => setNewAddress(e.target.value)} />

                        <div style={{ marginTop: "15px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                            <button onClick={() => setIsOpen(false)}>Cancel</button>
                            <button onClick={handleAddTimelineEntry}>Add</button>
                        </div>
                    </div>
                )}

                {/* Background Overlay */}
                {isOpen && (
                    <div onClick={() => setIsOpen(false)} style={{
                        position: "fixed",
                        top: "0", left: "0", width: "100%", height: "100%",
                        background: "rgba(0, 0, 0, 0.3)", zIndex: 999,
                    }} />
                )}
            </div>
        </DragDropContext>
    );
};

export default BookingEditView;
